<template lang="html">
  <div>
    <h1>PLAYLIST PRO GAMES</h1>
    <v-layout>
      <v-text-field solo label="Name" v-model="name"></v-text-field>
      <v-btn @click="create" text color="success">add new game</v-btn>
      
    </v-layout>
    <v-divider/>
    <v-layout>
      <v-text-field @input="syncFilter" small label="Search" v-model="search.str"></v-text-field>
      <v-layout>
        <v-text-field @input="seatchMethod" v-model="searchSubgoals" solo label="Search subgoal"></v-text-field>
      </v-layout>
      <v-select
        @input="syncFilter"
        label="Suboals"
        v-model="search.subgoals"
        chips
        :items="subgoalsFiltered"
        item-text="name"
        item-value="id"
        solo
        multiple
      ></v-select>
    </v-layout>
    <v-data-table
      v-if="data.length"
      :hide-default-footer="true"
      :items-per-page="search.perPage"
      :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'ORDER INDEX', value: 'order_index' },
        { text: 'NAME GAME', value: 'name' },
        { text: 'START DAY', value: 'date' },
        { text: 'CHILD', value: 'id_author' },
        { text: 'PINNED', value: 'pinned_value' },
        { text: 'PLAYED', value: 'played' },
        { text: 'LIKED', value: 'likes_value' },
        { text: 'STATUS', value: 'show' },
        { text: 'EDIT', value: 'actions', sortable: false },
      ]"
      :items="data"
      @click:row="(item) => {this.$router.push('/playdate-pro/' + item.id_playlist)}"
    >
     <template v-slot:item.id_author="{ item }">
      {{ item.id_author!=null ? true : false}}
    </template>
    <template v-slot:item.likes_value="{ item }">
      {{ item.likes!=null?item.likes.length:0}}
    </template>
    <template v-slot:item.pinned_value="{ item }">
      {{ item.pinned!=null?item.pinned:0}}
    </template>
      <template v-slot:item.date="{ item }">
        {{ new Date(item.date * 1000) | dateFormat('DD.MM.YY') }}
      </template>
      <template v-slot:item.show="{ item }">
  {{ item.show ? "VISIBLE" : "HIDDEN" }}
</template>
      <template v-slot:item.actions="{ item }">
  <v-btn text :to="'/playdate-pro/' + item.id_playlist" color="info">edit</v-btn>
</template>
    </v-data-table>
    <div id="main">
      <div style="display: inline-block;">
          <v-select
            style="margin-top: 10px;"
            label="Games to display"
            :value="search.perPage"
            :items="search.perPageRanges"
            item-text="title"
            item-value="value"
            dense
            outlined
            @change="perPageChange"
        ></v-select>
        </div>
        <div style="display: inline-block;">
          <paginate
            v-if="pagination.pages>1"
            v-model="search.page"
            :page-count="pagination.pages"
            :page-range="5"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
        <div style="display: inline-block; margin-left: 10px;">
          <label style="font-size:12px; font-family:sans-serif; font-weight: 500;">{{search.perPage*(search.page-1)+'-'+search.perPage*search.page}} of {{total}}</label>
        </div>
    </div>

    <v-snackbar
      v-model="alert.update"
      right
      top
      :timeout="2000"
    >
      Updated.
      <v-btn
        color="pink"
        flat
        @click="alert.update = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "playlist",
  data() {
    return {
      total: null,
      data: [],
      playlists: [],
      subgoalsFiltered: null, 
      name: "",
      alert: {
        update: false,
        delete: false,
      }, 
      indexes:{
        category:null,
        categorySearch:'',
        gamesSearch:'',
        gamesSearchLoc:''
      },
      group:{
        location:null,
        category:null,
        games:null,
        giftSearch:null,
        giftSearchFrom:null,
        giftSearchTo:null,
        gamesSearch:null,
      },
      locationsToGift:{
        location:null,
        category:null,
      },
      giftToLocations:{
        location:null,
        category:null,
      },
      giftToGift:{
        categoryFrom:null,
        categoryTo:null,
      },
      search: {
        str: "",
        categories: [],
        subgoals: [],
        level: null,
        page: 1,
        perPage: 15,
        perPageRanges:[
          {    
            value: 5,
            title: '5'
          },
          {    
            value: 10,
            title: '10'
          },
          {    
            value: 15,
            title: '15'
          },
          {    
            value: 20,
            title: 'All'
          },]
      },
      categories: "",
      categoriesGroup: "",
      indexesCategories: "",
      categoriesGroupFrom: "",
      subgoals: "",
      locationsLoc: "",
      searchSubgoals:'',
      pagination: { 
        page: 1,
        pages: 1,
       },
       indexedArray:null,
       indexedArraySearch:null,
       indexedArrayLoc:null,
       indexedArrayLocSearch:null,
      dialog:{
        locationIndexes:false,
        giftsIndexes:false,
        groupSetting:false,
        locationsToGift:false,
        giftToLocations:false,
        giftToGift:false,
      }
    };
  },
  methods: {
    seatchMethod(val) {
      if (this.searchSubgoals == '') {
        this.subgoalsFiltered = this.subgoals.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      }
      else {
        this.subgoalsFiltered = this.subgoals.filter(element => {
          return (element.name).includes(this.searchSubgoals)
        });
      }
    },
    filters(e){
      console.log('ok');
    },
    syncFilter(){
      console.log('this')
      this.search.page = 1;
      this.pagination.pages = 1;
      this.data = [];
      this.sync();
    },
    updateIndexesNew(){
      console.log(this.indexedArray);
      axios
        .post("/playlist/updateIndexes", {
          data: this.indexedArray,
        })
        .then((res) => {
          console.log(res.data)
          this.dialog.giftsIndexes = false;
          this.indexedArray=null;
          this.indexes.category=null;
          this.indexes.categorySearch='';
        })
        .catch((err) => {
          this.dialog.giftsIndexes = false;
          this.indexedArray=null;
          this.indexes.category=null;
          this.indexes.categorySearch='';
        });
    },
    updateIndexesNews(){
      axios
        .post("/playlist/updateIndexesbyLocation", {
          data: this.indexedArrayLoc,
        })
        .then((res) => {
          console.log(res.data)
          this.dialog.locationIndexes = false;
          this.indexedArrayLoc=null;
          this.indexes.location=null;
          this.indexes.locationSearch='';
        })
        .catch((err) => {
          this.dialog.locationIndexes = false;
          this.indexedArrayLoc=null;
          this.indexes.location=null;
          this.indexes.locationSearch='';
        });
    },
    perPageChange(item){
      if(item!='All')
      {
        this.search.perPage=item;
        this.search.page = 1;
        this.sync();
      }
      else
      {
        this.search.perPage=this.total;
        this.search.page = 1;
        this.sync();
      }
    },
    clickCallback: function(page) {
      this.sync();
    },
    clearLocation(){
      this.group.location = null;
    },
    clearGames(){
      this.group.games = null;
    },
    clearGift(){
      this.group.category = null;
    },
    giftToLocationsSend(){
      console.log(this.giftToLocations);
      axios.post('/playlist/updateGiftToLocation',{data:this.giftToLocations}).then(()=>{
        this.alert.update = true;
      })
    },
    giftToGiftSend(){
      console.log(this.giftToGift);
      axios.post('/playlist/updateGiftToGift',{data:this.giftToGift}).then((res)=>{
        this.alert.update = true;
      })
    },
    locationsToGiftSend(){
      console.log(this.locationsToGift);
      axios.post('/playlist/updateLocationToGift',{data:this.locationsToGift}).then(()=>{
        this.alert.update = true;
      })
    },
    groupSaveData(){
      console.log(this.group)
      axios.post('/playlist/updateGiftsAndLocations',{data:this.group}).then(()=>{
        this.alert.update = true;
      })
    },
    filterGroupGifts(e){
      this.categoriesGroup = this.categories.filter(x=>x.name.toLowerCase().includes(e.toLowerCase()));
    },
    filterGroupGiftsFrom(e){
      this.categoriesGroupFrom = this.categories.filter(x=>x.name.toLowerCase().includes(e.toLowerCase()));
    },
    filterGroupIndexesGiftsFrom(e){
      this.indexesCategories = this.categories.filter(x=>x.name.toLowerCase().includes(e.toLowerCase()));
    },
    filterGroupIndexesLocationFrom(e){
      this.locationsLoc = this.locations.filter(x=>x.name.toLowerCase().includes(e.toLowerCase()));
    },
    filterGroupIndexesGamesGift(e){
      this.indexedArraySearch = this.indexedArray.filter(x=>x.name.toLowerCase().includes(e.toLowerCase()));
    },
    filterGroupIndexesGamesLoc(e){
      this.indexedArrayLocSearch = this.indexedArrayLoc.filter(x=>x.name.toLowerCase().includes(e.toLowerCase()));
    },
    filterGroupGiftsTo(e){
      this.categoriesGroupTo = this.categories.filter(x=>x.name.toLowerCase().includes(e.toLowerCase()));
    },
    filterGroupGames(e){
      this.playlists = this.data.filter(x=>x.name.toLowerCase().includes(e.toLowerCase()));
    },
    editLocationToGift(){
      this.dialog.locationsToGift = true;
    },
    editGiftToLocation(){
      this.dialog.giftToLocations = true;
    },
    editGiftToGift(){
      this.dialog.giftToGift = true;
    },
    edit(){
      this.dialog.groupSetting = true;
    },
    editIndexForGift(){
      this.dialog.giftsIndexes = true;
    },
    editIndexForLoc(){
      this.dialog.locationIndexes = true;
    },
    dataToDisplay(){
      return this.data;
    },
    
    syncIndexes() {
      axios
        .post("/playlist/byCategory", {
          query: this.indexes.category,
        })
        .then((res) => {
         this.indexedArray = res.data.sort(function ( a, b ) { 
            return (a.order_index===null)-(b.order_index===null) || +(a.order_index>b.order_index)||-(a.order_index<b.order_index);
          });;
          this.indexedArraySearch = res.data.sort(function ( a, b ) { 
            return (a.order_index===null)-(b.order_index===null) || +(a.order_index>b.order_index)||-(a.order_index<b.order_index);
          });;
        //  console.log(this.indexedArray);
        })
        .catch((err) => {
         
        });
    },
    syncIndexesLoc() {
      axios
        .post("/playlist/byLocation", {
          query: this.indexes.location,
        })
        .then((res) => {
         this.indexedArrayLoc = res.data.sort(function ( a, b ) { 
          return (a.order_index===null)-(b.order_index===null) || +(a.order_index>b.order_index)||-(a.order_index<b.order_index);
          });;
          this.indexedArrayLocSearch = res.data.sort(function ( a, b ) { 
          return (a.order_index===null)-(b.order_index===null) || +(a.order_index>b.order_index)||-(a.order_index<b.order_index);
          });;
        })
        .catch((err) => {
         
        });
    },
    sync() {
      axios
        .post("/playlist/full", {
          query: this.search,
        })
        .then((res) => {
          console.log(res.data)
          if(typeof res.data.items == 'array')
          {
            this.data = res.data.items;
          }
          else
          {
            this.data = Object.values(res.data.items)
          }
            this.pagination.pages = Math.ceil(res.data.total/this.search.perPage);
            this.playlists = this.data;
            this.search.perPageRanges[3].value = res.data.total;
            this.total = res.data.total;
        })
        .catch((err) => {
          axios
            .post("/playlist/full", {
              query: this.search,
            })
            .then((res) => {
              this.data = res.data;
            });
        });
    },
    syncCategories() {
      axios.get("/playlist/categories").then((res) => {
        this.categories = res.data;
        this.categoriesGroup = this.categories;
        this.categoriesGroupFrom = this.categories;
        this.categoriesGroupTo = this.categories;
        this.indexesCategories = this.categories;
      });
    },
    syncLocations() {
      axios.get("/playlist/settings").then((res) => {
        this.locations = res.data;
        this.locationsLoc = res.data;
      });
    },
    syncSubGoals() {
      axios.get("/admin/treatment/getSubGoals").then((res) => {
                    this.subgoals = res.data.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });

        this.subgoalsFiltered = res.data.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
      });
    },
    create() {
      axios
        .post("/playlist", {
          name: this.name,
        })
        .then((res) => {
          this.sync();
          this.name = "";
          alert('Playlist code was added');
        }).catch(err => {
          alert('Oops! Something went wrong. Please try again or contact the technical team.');
        });
    },
  },
  activated(){
    this.sync();
    this.syncLocations();
    this.syncCategories();
    this.syncSubGoals();
  },
  created() {
    this.sync();
    this.syncLocations();
    this.syncCategories();
    this.syncSubGoals();
  },
};
</script>

<style lang="scss" scoped>
.pagination {
    display: inline-block;
    padding-left: 0;
    margin: -10px 5px !important;
    border-radius: 4px;
}
</style>
